import React, { useState, useEffect,  Suspense, lazy, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { flowType } from '@utility/userInfo';
import { setLoggingOut } from '@reducers/oauth';
import EventEmitter from '@utility/eventSubscribers';
import { urlSearchParams } from '@utility/utills';
import Loader from '@components/common/Loader/newLoaderModal';
import { APP_CONFIG } from '@constants';
import getDeviceType from '@utility/deviceType';
import { safeJsonParse } from '../../utility/helperFunction';
const Login = lazy(() => import('@containers/LoginContainer'));
const TableSelection = lazy(() => import('@containers/TableTop/tableSelection'));

const CheckIn = (props) => {
  // Props Destructuring

  const {deviceInfo, setLoggingOut} = props;

  // State Management

  const [step, setStep] = useState(1);
  const type = flowType();
  const isServerApp = type === 'serverApp';
  const isTableTop = type === 'tableTop';
  const param = Number(urlSearchParams('step'));

  useEffect(() => {
    // responsible for resetting the loader on mount;
    // set true in -> CheckList Header, Inactivity Timer
    setLoggingOut(false);
  }, []);

  useEffect(() => {
    requestIdleCallback(() => {
      setStep(Number(urlSearchParams('step')) || 1);
    });
  }, [param]);

  // Methods

  const goToCashIn = () => {
      if (safeJsonParse(window.sessionStorage.getItem('userInfo'), {})?.requireCashIn) {
        props.navigate(`${APP_CONFIG.BASE_URL}/cashIn`, { replace: true });
      } else {
        props.navigate(`/${type}/checks?login=true`, { replace: true });
      }
  };

  const goTOGuestInfo = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/callcenter/guestinformation`, { replace: true });
  };

  const onCounterLogin = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks?login=true`, { replace: true });
  };

  const onSucessLogin = () => {
    const type = flowType();
    const { isCounter, isCallCenter } = getDeviceType();
    switch (type) {
      case 'tableTop': props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=2`, { replace: true }); break;
      case 'kiosk': props.navigate(`${APP_CONFIG.BASE_URL}/kiosk/landing`, { replace: true }); break;
      case 'serverApp':
        if (isCallCenter) {
          goTOGuestInfo();
        } else if (isCounter) {
          props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks?login=true`, { replace: true });
        } else {
          goToCashIn();
        }
        break;
      default: props.navigate(`${APP_CONFIG.BASE_URL}/${type}/checks`); if (window.ReactNativeWebView && (isServerApp || isTableTop)) {
        EventEmitter.changeOrientation({
          orientation: "landscape"
        })
      } break;
    }
  };

  const onSucessTableTop = (data) => {
    props.navigate(`${APP_CONFIG.BASE_URL}/${type}/checks`, {
      replace: true,
      state: {
        ...data
      }
    });
  };

  const handleActivateRoute = () => {
    window.sessionStorage.clear();
    window.localStorage.clear();
    props.navigate(`${APP_CONFIG.BASE_URL}/activate?reactivate=true`, { replace: true });
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <Login isNotLoginPage onCallBack={onSucessLogin} handleActivateRoute={handleActivateRoute} onCounterLogin={onCounterLogin} />;
      case 2:
        return <TableSelection {...props} onCallBack={onSucessTableTop} />;
      case 4:
        return props.navigate(`${APP_CONFIG.BASE_URL}/orderUp/checks`, { replace: true });
      case 5:
        return <Login isNotLoginPage onCallBack={onSucessLogin} handleActivateRoute={handleActivateRoute} />;
      case 6:
        return props.navigate(`${APP_CONFIG.BASE_URL}/fireboard`, { replace: true });
      default:
        return <div className="h-100 w-100 fs-30 text-center row mx-0 align-items-center justify-content-center">DEVICE TYPE NOT SUPPORTED</div>;
    }
  };

  const StepComponent = useMemo(() => renderStepContent(), [step, deviceInfo]);
  // HTML CSS Code

  return (
    <Suspense fallback={<Loader />}>
      {StepComponent}
    </Suspense>
  );
};

// Redux Part

const mapStateToProps = ({ oauth }) => ({
  loading: oauth.loading,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  loggedInUser: oauth.loggedInUser,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setLoggingOut }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(CheckIn));
